'use strict';

var quantityModuleClass = '.quantity.attribute';
var quantitySelectClass = '.quantity-select';
var quantityInputClass = '.quantity-input';
var quantityPlusClass = '.quantity-right-plus';
var quantityMinusClass = '.quantity-left-minus';
var debounce = require('lodash/debounce');

var exportQuantitySelect = {
	/**
     * Initialize the Quantity Selector widget and Query event handlers.
     */
	initQuantitySelector: function () {
		var qtySelectorInputHandler = function (e) {
			var $qty = $(this).parents(quantityModuleClass);
			var $qtyInput = $qty.find(quantitySelectClass).find('option:selected');
			var $input = $qty.find(quantityInputClass);
			var $plus = $qty.find(quantityPlusClass);
			var $minus = $qty.find(quantityMinusClass);
			var quantities = exportQuantitySelect.getQtyArray($qtyInput);
			var currentIndex = quantities.indexOf($qtyInput.val());
			var newVal = null;
			var newIndex;

			// if the input field triggered the event but its value didn't change, EXIT
			if ($(this).is($input) && $input.data('previous-value').toString() === $input.val()) {
				return;
			}

			if ($(this).is($minus)) {
				// minus was clicked
				newIndex = currentIndex - 1;
				newVal = quantities[newIndex] ? quantities[newIndex] : quantities[quantities.length - 1];
			} else if ($(this).is($plus)) {
				// plus was clicked
				newIndex = currentIndex + 1;
				newVal = quantities[newIndex];
			} else {
				// was updated via the input text field
				newVal = $(this).val();
				newIndex = quantities.indexOf(newVal);
			}
			if (typeof newVal === 'undefined') {
				return;
			}

			// attempt to change the <input> value
			$qtyInput.trigger({
				type: 'change',
				newVal: newVal
			});

			// if it did not work, reset input field to previous value and EXIT
			if ($qtyInput.val().toString() !== newVal.toString()) {
				e.preventDefault();
				$input.val($input.data('previous-value'));
				return;
			}
			// if it did work, update input field
			exportQuantitySelect.updateTextField($qtyInput);
		};

		var selectChangeHandler = function (e) {
			var newVal = e.newVal || $(this).find('option:selected').val();
			var setItemEle = $(this).parents('.product-detail.set-item');
			var isProductSet = setItemEle && setItemEle.length > 0 ? true : false;
			var quantities = exportQuantitySelect.getQtyArray($(this).find('option:selected'));
			var $product = $(this).closest('.product-detail');
			var shippingQty = $product.find('.shipping-msg').attr('data-qty');
			var pickupQty = $product.find('.pickup-msg').attr('data-qty');
			var dataqty = shippingQty;
			var inventoryQty;
			if (parseInt(shippingQty)) {
				inventoryQty = parseInt(shippingQty);
			} else if(pickupQty) {
				inventoryQty = parseInt(pickupQty);
			} else {
				inventoryQty = 0;
			}

			// check if the value exists as an option, and if not, EXIT
			if(newVal == '0'){
				return false;
			}
			else if (quantities.indexOf(newVal) < 0) {
				e.preventDefault();
				var msg = $(quantityInputClass).attr('data-limit-exceed-error');
				if ($('.quantity-error-message').length && $('.quantity-error-message').hasClass('d-none')) {
					$('.quantity-error-message').removeClass('d-none');
					$('.item-exceed-error').text(msg);
				}
				setTimeout(function () {
					$('.quantity-error-message').addClass('d-none');
				}, 3000);
				return false;
			}
			else if(typeof dataqty === 'undefined' || dataqty === 'null'){

				var $pdpContainer = isProductSet ? setItemEle : $(this).closest('.product-detail');
				var shippingStock = $pdpContainer.find('.shipping-delivery-selection .availability-msg');
				var pickupStoreStock = $pdpContainer.find('.shipping-pickup-store .availability-msg');
				var pdpStockMsgShown = shippingStock.find('.inStock').length > 0 || shippingStock.find('.outOfStock').length > 0 || 
										pickupStoreStock.find('.inStock').length > 0 || pickupStoreStock.find('.outOfStock').length > 0 ? true : false;

				if ($pdpContainer.find('.variation-value.selected').length === $pdpContainer.find('.variationOption').length && !pdpStockMsgShown) {
					// If all variation options selected and no stock messages shown, whether OOS/IS this implies 
					// selected variation not available for product.Then show not available message, else continue to appropriate error msg
					$pdpContainer.find('.variation-selection-error-message').removeClass('d-none');
					$pdpContainer.find('.selection-error-message').text($(this).parents('.attributes').find('button.add-to-cart').attr('data-not-available'));
				}else if ($('.variation-selection-error-message').length && $('.variation-selection-error-message').hasClass('d-none')) {
					varaitionNotSelectedError($pdpContainer);
				}
				return false;
			}
			else if(parseInt(newVal) > inventoryQty){
				e.preventDefault();
				var ErrorQtymsg = $(quantityInputClass).attr('data-inventory-available-error');

				let ErrormszPart = ErrorQtymsg.split('only');
				var msgInventory =('only ' + inventoryQty + ErrormszPart[1]);

				if ($('.quantity-error-message').length && $('.quantity-error-message').hasClass('d-none')) {
					$('.quantity-error-message').removeClass('d-none');
					$('.item-exceed-error').text(msgInventory);
				}
				setTimeout(function () {
					$('.quantity-error-message').addClass('d-none');
				}, 3000);
				
				// set the <select> value
				if ($(this).val() !== newVal) {
					$(this).val(inventoryQty);
				}
				exportQuantitySelect.updateTextField($(this));
				return $(this);

			}
			// set the <select> value
			if ($(this).val() !== newVal) {
				$(this).val(newVal);
			}

			// update the <input> value
			exportQuantitySelect.updateTextField($(this));

			return $(this);
		};

		// init jQuery event handlers
		var plusSelector = quantityModuleClass + ' ' + quantityPlusClass + ':not(.disabled):not([disabled])';
		var minusSelector = quantityModuleClass + ' ' + quantityMinusClass + ':not(.disabled):not([disabled])';
		var inputSelector = quantityModuleClass + ' ' + quantityInputClass + ':not(.disabled):not([disabled])';
		var selectboxSelector = quantityModuleClass + ' ' + quantitySelectClass + ':not(.disabled):not([disabled])';

		$(document).on('change click', plusSelector + ', ' + minusSelector + ', ' + inputSelector, qtySelectorInputHandler);
		$(document).on('change', selectboxSelector, selectChangeHandler);
		$(document).on('keyup', inputSelector, debounce(qtySelectorInputHandler, 1000));
		$(document).on('validateButtons', selectboxSelector, function () { exportQuantitySelect.updateTextField($(this)); });

		$(quantityInputClass).keypress(function (e) {
			var keyCode = e.which ? e.which : e.keyCode;
			if (!(keyCode >= 48 && keyCode <= 57)) {
				return false;
			}
			if (this.value.length > 2) {
				this.value = this.value.slice(0, 1);
				return false;
			}
			return true;
		});
		$(document).on('click', '.close-cta', function () {
			$('.quantity-error-message').addClass('d-none');
		});
	},
	/**
     * Get the values of the quantity in a JS array format
     * @param {Object} $qtyInput - a jQuery object representing the <input> element to retrieve values from
     * @return {Object} - Retruns the qty values as an array.
     */
	getQtyArray: function ($qtyInput) {
		if ($qtyInput) {
			var qtys = [];
			for (var i = $qtyInput.attr('min'); i <= $qtyInput.attr('max'); i++) {
				qtys.push(i.toString());
			}
			return qtys;
		}
	},
	/**
     * Updates the displayed value in the widget's text input field.
     * @param {Object} $scope - a jQuery object representing either parent .quantity-module wrapper, or one of its children
     * @return {Object} - Returns the same object param for jQuery function chaining, if needed.
     */
	updateTextField: function ($scope) {
		if ($scope) {
			var $qty = $scope.is(quantityModuleClass) ? $scope : $scope.parents(quantityModuleClass);
			var $qtyInput = $qty.find(quantitySelectClass).find('option:selected');
			var $input = $qty.find(quantityInputClass);
			var $plus = $qty.find(quantityPlusClass);
			var $minus = $qty.find(quantityMinusClass);
			var quantities = exportQuantitySelect.getQtyArray($qtyInput);
			var currentIndex = quantities.indexOf($qtyInput.val());

			// disable plus/minus buttons if needed
			if (currentIndex === 0) {
				$minus.addClass('disabled').attr('disabled', 'disabled');
			} else {
				$minus.removeClass('disabled').removeAttr('disabled');
			}
			if (currentIndex === quantities.length - 1) {
				$plus.addClass('disabled').attr('disabled', 'disabled');
			} else {
				$plus.removeClass('disabled').removeAttr('disabled');
			}

			// update the displayed value
			$input.val($qtyInput.val());

			// reset previous-value tracker
			$input.data('previous-value', $input.val());
		}
		return $scope;
	}
};

function varaitionNotSelectedError($pdpContainer) {
	let nonSelectedVariations = $pdpContainer.find('.variationOption').not(':has(.variation-value.selected)');
	for (let i = 0; i < nonSelectedVariations.length; i++) {
		let errorMsg = $(nonSelectedVariations[i]).data('attr-missing-error');
		$(nonSelectedVariations[i]).addClass('variation-missing-error');
		$(nonSelectedVariations[i]).find('.variation-not-selected-error').text(errorMsg);
		$(document).trigger('gtm:pdpVariationErrors', errorMsg);
	}
	if($pdpContainer.find('.variation-missing-error').length > 0) {
		$(document).scrollTop($pdpContainer.find('.variation-missing-error').offset().top);
	}
}

module.exports = exportQuantitySelect;
